import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const T = {
  bg:'#07080c', bg2:'#0c0f18', border:'rgba(255,255,255,.07)',
  white:'#dce6fa', muted:'rgba(220,230,250,.45)', dim:'rgba(220,230,250,.22)',
  cyan:'#00c8f0', blue:'#4d8fff', yellow:'#f1c40f', green:'#2ecc71',
  sans:'"Syne","DM Sans",system-ui,sans-serif',
};

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function VerifyRequiredPage() {
  const { user, logout, apiFetch } = useAuth();
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);

  const resend = async () => {
    setLoading(true);
    try {
      await apiFetch('/api/auth/resend-verification/', { method: 'POST' });
      setSent(true);
    } catch {}
    setLoading(false);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800;900&family=DM+Sans:wght@400;500;600&display=swap');
        * { box-sizing:border-box; margin:0; padding:0; }
        @keyframes spin { to { transform:rotate(360deg); } }
        @keyframes float {
          0%,100% { transform:translateY(0); }
          50%      { transform:translateY(-8px); }
        }
      `}</style>

      <div style={{
        minHeight:'100vh', background:T.bg,
        display:'flex', alignItems:'center', justifyContent:'center',
        padding:'24px', fontFamily:T.sans,
        backgroundImage:`linear-gradient(rgba(255,255,255,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.025) 1px,transparent 1px)`,
        backgroundSize:'60px 60px',
      }}>
        <div style={{ width:'100%', maxWidth:460, textAlign:'center' }}>

          {/* Animated icon */}
          <div style={{
            fontSize:64, marginBottom:24,
            animation:'float 3s ease-in-out infinite',
            display:'inline-block',
          }}>📧</div>

          <h1 style={{
            fontSize:'clamp(1.5rem,4vw,2rem)', fontWeight:900,
            color:T.white, letterSpacing:'-.03em', marginBottom:12,
          }}>
            Verify your email to continue
          </h1>

          <p style={{ fontSize:14, color:T.muted, lineHeight:1.75, marginBottom:28, maxWidth:360, margin:'0 auto 28px' }}>
            We sent a verification link to{' '}
            <strong style={{ color:T.white }}>{user?.email}</strong>.
            Click the link in that email to unlock your dashboard and all tools.
          </p>

          {/* Main card */}
          <div style={{
            background:'rgba(255,255,255,.025)',
            border:`1px solid ${T.border}`,
            borderRadius:16, padding:'24px',
            marginBottom:16,
          }}>
            <div style={{
              display:'grid', gridTemplateColumns:'1fr 1fr 1fr',
              gap:10, marginBottom:24,
            }}>
              {[
                { icon:'🔒', label:'Dashboard locked' },
                { icon:'🤖', label:'AI tools locked' },
                { icon:'🛠️', label:'All tools locked' },
              ].map(item => (
                <div key={item.label} style={{
                  padding:'12px 8px',
                  background:'rgba(255,255,255,.03)',
                  border:`1px solid ${T.border}`,
                  borderRadius:10,
                }}>
                  <div style={{ fontSize:20, marginBottom:5 }}>{item.icon}</div>
                  <div style={{ fontSize:11, color:T.dim, lineHeight:1.4 }}>{item.label}</div>
                </div>
              ))}
            </div>

            {sent ? (
              <div style={{
                padding:'12px 16px', borderRadius:9,
                background:`${T.green}12`, border:`1px solid ${T.green}40`,
                fontSize:13.5, color:T.green, fontWeight:600, marginBottom:14,
              }}>
                ✓ Verification email sent! Check your inbox and spam folder.
              </div>
            ) : (
              <button onClick={resend} disabled={loading} style={{
                width:'100%', padding:'12px', border:'none', borderRadius:9,
                background:`linear-gradient(135deg,${T.cyan},${T.blue})`,
                color:'#07080c', fontSize:14, fontWeight:700, fontFamily:T.sans,
                cursor: loading ? 'default' : 'pointer',
                display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                marginBottom:14, opacity: loading ? .6 : 1,
              }}>
                {loading && (
                  <div style={{ width:14, height:14, borderRadius:'50%', border:'2px solid rgba(0,0,0,.3)', borderTopColor:'#07080c', animation:'spin .65s linear infinite' }}/>
                )}
                {loading ? 'Sending…' : '📨 Resend verification email'}
              </button>
            )}

            <div style={{ fontSize:12.5, color:T.dim, lineHeight:1.65 }}>
              Check your spam folder if you don't see it.
              The link expires in 24 hours.
            </div>
          </div>

          {/* Already verified? */}
          <div style={{ fontSize:12.5, color:T.muted, marginBottom:8 }}>
            Already clicked the link?{' '}
            <button onClick={() => window.location.reload()} style={{
              background:'none', border:'none', color:T.cyan, cursor:'pointer',
              fontSize:12.5, fontFamily:T.sans,
            }}>
              Refresh the page →
            </button>
          </div>

          {/* Wrong email? Sign out */}
          <button onClick={logout} style={{
            background:'none', border:'none', color:T.dim, cursor:'pointer',
            fontSize:12, fontFamily:T.sans,
          }}>
            Wrong email? Sign out and use a different account
          </button>
        </div>
      </div>
    </>
  );
}